import { z } from 'zod';
import { DefinitionDraftSchema, QuerySpecSchema, } from './metrics-catalog.js';
import { AnalyticsModelTierSchema, RecentQuestionSchema } from './analytics-board.js';
export const DefinitionDraftRequestSchema = z.object({
    kind: z.enum(['source', 'dimension', 'metric']),
    request: z.string().trim().min(1).max(2000),
});
export { DefinitionDraftSchema } from './metrics-catalog.js';
export const DefinitionDraftResponseSchema = z.object({
    draft: DefinitionDraftSchema,
    explanation: z.string().min(1).max(1500),
});
export const AnalyticsSummaryRequestSchema = z.object({
    query: QuerySpecSchema,
});
export const AnalyticsSummarySchema = z.object({
    text: z.string().min(1).max(2000),
    summarizedRows: z.number().int().nonnegative(),
    totalRows: z.number().int().nonnegative(),
    limited: z.boolean(),
});
export const MissingQuestionsPageSchema = z.object({
    items: z.array(RecentQuestionSchema),
    page: z.number().int().positive(),
    total: z.number().int().nonnegative(),
});
// 공개 기본 단가(USD/100만 토큰), 2026-10-29 확인: https://platform.claude.com/docs/en/about-claude/pricing
export const RECOMMENDATION_MODELS = [
    { value: 'haiku', label: 'Claude Haiku 4.5', inputUsdPerMillion: 1, outputUsdPerMillion: 5 },
    { value: 'sonnet46', label: 'Claude Sonnet 4.6', inputUsdPerMillion: 3, outputUsdPerMillion: 15 },
    { value: 'sonnet', label: 'Claude Sonnet 5', inputUsdPerMillion: 2, outputUsdPerMillion: 10 },
    { value: 'opus', label: 'Claude Opus 4.8', inputUsdPerMillion: 5, outputUsdPerMillion: 25 },
];
export const RecommendationModelTierSchema = AnalyticsModelTierSchema;
export const MetricRecommendationRequestSchema = z.object({
    focus: z.string().trim().max(500).default(''),
    modelTier: RecommendationModelTierSchema.default('sonnet46'),
});
export const MetricRecommendationSchema = z.object({
    key: z
        .string()
        .regex(/^[a-z][a-z0-9_]*$/)
        .max(64),
    label: z.string().trim().min(1).max(100),
    purpose: z.string().trim().min(1).max(500),
    calculation: z.string().trim().min(1).max(500),
    exampleQuestion: z.string().trim().min(1).max(300),
    tableNames: z.array(z.string().min(1).max(64)).min(1).max(4),
    sourceKeys: z.array(z.string().min(1).max(64)).max(4),
    metricKeys: z.array(z.string().min(1).max(64)).max(4),
    topicKeys: z.array(z.string().min(1).max(64)).max(4),
});
export const RecommendationTableProfileSchema = z.object({
    name: z.string(),
    sampledRows: z.number().int().min(0).max(1000).nullable(),
    capped: z.boolean(),
    recentRows: z.number().int().min(0).max(1000).nullable(),
    recentCapped: z.boolean(),
    timeColumn: z.string().nullable(),
});
export const MetricRecommendationsSchema = z.object({
    items: z.array(MetricRecommendationSchema).max(6),
    tables: z.array(RecommendationTableProfileSchema),
    topics: z.array(z.object({
        key: z.string(),
        label: z.string(),
        count: z.number().int().positive(),
    })),
    range: QuerySpecSchema.shape.range,
    generatedAt: z.string().datetime(),
    limitations: z.array(z.string().max(500)).max(6),
});
//# sourceMappingURL=analytics-assistant.js.map